var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.345,
    height: 17.329,
    viewBox: "0 0 17.345 17.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calender",
    transform: "translate(0.006 0.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M607.074,434.483c0-.355-.01-.624,0-.9a.842.842,0,0,1,.877-.867.816.816,0,0,1,.823.9v.8h7.01V433.6a.805.805,0,0,1,.8-.879.852.852,0,0,1,.9.849c.016.28,0,.562,0,.84a11.566,11.566,0,0,1,1.527.136,2.429,2.429,0,0,1,1.913,2.255c.044.908.026,1.819.027,2.729,0,2.594-.017,5.189.007,7.783a2.587,2.587,0,0,1-1.95,2.656,3.394,3.394,0,0,1-.765.077q-5.95.007-11.9,0a2.528,2.528,0,0,1-2.636-1.911,2.836,2.836,0,0,1-.086-.72c0-3.436-.013-6.873,0-10.309a2.524,2.524,0,0,1,2.1-2.608A7.554,7.554,0,0,1,607.074,434.483Zm5.23,5.135c-2.172,0-4.345.007-6.521-.007-.354,0-.495.067-.489.464.02,2.376.009,4.753.011,7.13,0,.845.309,1.157,1.153,1.157h11.656c.844,0,1.153-.311,1.153-1.156,0-2.377-.008-4.754.011-7.13,0-.4-.137-.466-.489-.464-2.165.012-4.324,0-6.484,0Zm3.436-3.445h-6.928c-.089.456-.3.787-.8.825-.594.045-.829-.346-.971-.838h-.511c-.961,0-1.223.26-1.223,1.232,0,.537,0,.538.521.538h12.919c.081,0,.179.028.24-.007.106-.061.258-.153.27-.245.143-1.141-.2-1.518-1.332-1.516h-.385c-.251.664-.467.853-.933.84-.447-.016-.677-.234-.862-.831Z",
    transform: "translate(-603.62 -432.75)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M695.405,530.283a4.706,4.706,0,0,1-.527,0,.841.841,0,0,1-.769-.843.821.821,0,0,1,.751-.815,6.592,6.592,0,0,1,1.092,0,.821.821,0,0,1,.749.815.839.839,0,0,1-.734.834c-.187.026-.377.023-.567.033Z",
    transform: "translate(-686.74 -520.818)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M695.413,562.349a3.848,3.848,0,0,1-.821-.163.758.758,0,0,1-.447-.833.779.779,0,0,1,.711-.718,6.821,6.821,0,0,1,1.132,0,.815.815,0,0,1,.739.823.838.838,0,0,1-.741.826c-.187.024-.377.022-.567.032Z",
    transform: "translate(-686.768 -550.218)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M695.411,594.352a3.837,3.837,0,0,1-.82-.163.757.757,0,0,1-.443-.834.779.779,0,0,1,.713-.716,6.915,6.915,0,0,1,1.132,0,.815.815,0,0,1,.734.826.838.838,0,0,1-.744.823c-.187.024-.377.02-.566.029Z",
    transform: "translate(-686.769 -579.614)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M642.23,530.334c-.163-.011-.357-.009-.543-.038a.789.789,0,0,1-.687-.821.763.763,0,0,1,.685-.815,6.216,6.216,0,0,1,1.135-.008.79.79,0,0,1,.734.824.809.809,0,0,1-.734.831C642.635,530.328,642.444,530.324,642.23,530.334Z",
    transform: "translate(-637.959 -520.843)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M748.982,528.42c.189.011.381.01.571.037a.794.794,0,0,1,.7.851.773.773,0,0,1-.712.795,6.308,6.308,0,0,1-1.1.006.789.789,0,0,1-.744-.815.808.808,0,0,1,.758-.846,4.75,4.75,0,0,1,.527,0Z",
    transform: "translate(-735.961 -520.651)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M642.227,562.3a4.417,4.417,0,0,1-.489,0,.8.8,0,0,1-.758-.842.774.774,0,0,1,.734-.815,6.209,6.209,0,0,1,1.095,0,.788.788,0,0,1,.724.832.807.807,0,0,1-.739.822c-.187.024-.379.02-.571.028Z",
    transform: "translate(-637.94 -550.23)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M748.886,562.359c-.163-.011-.357-.009-.543-.037a.8.8,0,0,1-.689-.821.778.778,0,0,1,.693-.815,6.362,6.362,0,0,1,1.135,0,.775.775,0,0,1,.724.826.8.8,0,0,1-.731.822C749.291,562.353,749.1,562.349,748.886,562.359Z",
    transform: "translate(-735.92 -550.261)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M642.305,592.42c.163.011.357.009.544.037a.8.8,0,0,1,.693.821.781.781,0,0,1-.69.82,6.216,6.216,0,0,1-1.135.007.776.776,0,0,1-.728-.822.793.793,0,0,1,.724-.83C641.9,592.427,642.091,592.431,642.305,592.42Z",
    transform: "translate(-637.948 -579.434)",
    fill: "#d3cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M748.965,592.42c.176.011.354.01.527.037a.791.791,0,0,1,.7.81.774.774,0,0,1-.712.835,6.211,6.211,0,0,1-1.135,0,.781.781,0,0,1-.705-.807.8.8,0,0,1,.718-.84C748.557,592.427,748.762,592.431,748.965,592.42Z",
    transform: "translate(-735.905 -579.434)",
    fill: "#d3cfcf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.972e133ebef8d9ee44cacf8d13310b80.svg";
export { ForwardRef as ReactComponent };